import styles from './styles.module.scss'
import HouseDetails from '../../../../custom/HouseDetails'
import Reservation from './components/Reservation'
import Button from '../../../../elements/Button'
import IconHeart from '/public/icons/icon-favourite.svg'
import IconShare from '/public/icons/icon-share.svg'
import { useResponsive } from '../../../../../providers/ResponsiveContext'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { useState } from 'react'
import { withModifiers } from '../../../../helpers/withModifiers'
import IconExpand from '/public/icons/icon-expand-up.svg'
import { useEffect } from 'react'
import Dropdown from '../../../../elements/Dropdown'
import {
  FacebookShareButton,
  LinkedinShareButton,
  PinterestShareButton,
  EmailShareButton
} from 'react-share'
import FacebookIcon from '/public/icons/icon-facebook.svg'
import PinterestIcon from '/public/icons/icon-pinterest.svg'
import LinkedinIcon from '/public/icons/icon-linkedin.svg'
import EmailIcon from '/public/icons/icon-email.svg'
import IconCheck from '/public/icons/icon-checkbox-check.svg'
import IconCopy from '/public/icons/icon-copy.svg'
import { CSSTransition } from 'react-transition-group'
import { useRouter } from 'next/router'
import Estate from './components/Estate'
import includes from 'lodash-es/includes'
import IconMoon from '/public/icons/icon-moon.svg'
import IconCar from '/public/icons/icon-car.svg'
import IconGift from '/public/icons/icon-gift.svg'
import { useFavouritesContext } from '/providers/favouritesProvider'

const Card = ({
  expandable = false,
  header = true,
  property,
  variant = [],
  translations,
  cardTranslations,
  ...props
}) => {
  const router = useRouter()
  const { addOrRemoveFavourite, isFavourite } = useFavouritesContext()
  const isRealEstate = router.pathname.includes('real-estate')
  const { isDesktop, isTablet, isSmallMobile } = useResponsive()
  const [show, setShow] = useState(expandable ? true : false)
  const [width, setWidth] = useState(0)
  const [loaded, setLoaded] = useState(0)
  const [copied, setCopied] = useState(false)
  const [bonuses, setBonuses] = useState({
    car: false,
    night: false,
    gift: false
  })

  useEffect(() => {
    !show ? setWidth(200) : setWidth(0)
  }, [show])

  function isButtonDisabled() {
    if (property.is_active) {
      return !property.is_active
    }
    if (isRealEstate && property?.sold) {
      return true
    }
  }
  useEffect(() => {
    setLoaded(true)
  }, [])

  if (!loaded) {
    return
  }

  return (
    <div
      className={withModifiers(
        'card',

        [
          expandable && show && isDesktop && 'collapsed',
          expandable && 'welcome',
          ...variant
        ],
        styles
      )}
    >
      {isDesktop && expandable && (
        <div
          onClick={() => setShow(!show)}
          className={withModifiers(
            'card__expand',
            [show && 'is-rotated'],
            styles
          )}
        >
          <IconExpand width={isDesktop ? 13 : 21} height={isDesktop ? 8 : 21} />
        </div>
      )}
      <div className={styles.card__header}>
        <div className={styles.card__intro}>
          <div
            style={{ maxWidth: isDesktop ? width : 'auto' }}
            className={styles.card__details}
          >
            <HouseDetails
              variant={['close']}
              persons={property?.bedrooms ? property?.bedrooms * 2 : false}
              bathrooms={property?.bathroom_no || property?.bathrooms}
              bedrooms={property?.bedroom_no || property?.bedrooms}
            />
          </div>

          <div className={styles.card__buttons}>
            {header && (
              <>
                <Button
                  // className={styles.card__heart}
                  className={withModifiers(
                    'card__heart',
                    [isFavourite(property.id) && 'is-active'],
                    styles
                  )}
                  appendIcon={<IconHeart width={17} />}
                  arrow={false}
                  onClick={() => addOrRemoveFavourite(property.id)}
                  variant={['label', 'close']}
                >
                  <span
                    className={styles.card__label}
                    style={{ width: !isDesktop ? 'auto' : !show ? 44 : 0 }}
                  >
                    {translations?.save[router.locale]}
                  </span>
                </Button>
                <Dropdown
                  variant={['socials']}
                  buttonVariant={['close']}
                  appendIcon={<IconShare />}
                  arrow={false}
                  title={
                    <span
                      className={styles.card__label}
                      style={{ width: !isDesktop ? 56 : !show ? 55 : 0 }}
                    >
                      {translations?.share[router.locale]}
                    </span>
                  }
                >
                  <div className={styles.card__socials}>
                    <FacebookShareButton
                      url={`${
                        typeof window !== 'undefined' && window?.location.href
                      }
                `}
                    >
                      <div
                        className={withModifiers(
                          'card__link',
                          ['facebook'],
                          styles
                        )}
                      >
                        <FacebookIcon width={16} height={16} />
                      </div>
                    </FacebookShareButton>
                    <LinkedinShareButton
                      url={
                        typeof window !== 'undefined' && window.location.href
                      }
                    >
                      <div
                        className={withModifiers(
                          'card__link',
                          ['linkedin'],
                          styles
                        )}
                      >
                        <LinkedinIcon width={16} height={16} />
                      </div>
                    </LinkedinShareButton>
                    <PinterestShareButton
                      url={
                        typeof window !== 'undefined' && window.location.href
                      }
                      media={
                        typeof window !== 'undefined' && window.location.href
                      }
                    >
                      <div
                        className={withModifiers(
                          'card__link',
                          ['pinterest'],
                          styles
                        )}
                      >
                        <PinterestIcon width={17} height={28} />
                      </div>
                    </PinterestShareButton>
                    <EmailShareButton
                      url={
                        typeof window !== 'undefined' && window.location.href
                      }
                      subject={translations.emailMessage[router.locale]}
                    >
                      <div className={styles.card__link}>
                        <EmailIcon width={16} height={16} />
                      </div>
                    </EmailShareButton>

                    <CopyToClipboard
                      text={
                        typeof window !== 'undefined' && window.location.href
                      }
                      onCopy={() => {
                        setCopied(true)
                        setTimeout(() => setCopied(false), 5000)
                      }}
                    >
                      <div className={styles.card__link}>
                        {!copied ? (
                          <CSSTransition
                            classNames="opacity"
                            appear={true}
                            timeout={{ enter: 200, exit: 200 }}
                            key={copied ? 'fire' : 'static'}
                          >
                            <IconCopy width={16} height={16} />
                          </CSSTransition>
                        ) : (
                          <CSSTransition
                            classNames="opacity"
                            appear={true}
                            timeout={{ enter: 200, exit: 200 }}
                            key={copied}
                          >
                            <IconCheck width={15} height={13} />
                          </CSSTransition>
                        )}
                      </div>
                    </CopyToClipboard>
                  </div>
                </Dropdown>
              </>
            )}

            {isSmallMobile && show && (
              <span
                className={styles.card__label}
                style={{ width: isSmallMobile ? 'auto' : show ? 155 : 0 }}
              >
                <Button
                  onClick={() => setShow(!show)}
                  variant={['xs', 'color-accent']}
                  arrow={false}
                  disabled={isButtonDisabled()}
                >
                  {isRealEstate
                    ? property?.sold
                      ? translations.sold[router.locale]
                      : translations.inquire[router.locale]
                    : translations.book[router.locale]}
                </Button>
              </span>
            )}

            {isTablet && !isSmallMobile && show && (
              <span
                className={styles.card__label}
                style={{
                  width:
                    !isRealEstate && (isSmallMobile ? 'auto' : show ? 157 : 0)
                }}
              >
                <Button
                  onClick={() => setShow(!show)}
                  variant={['xs', 'color-accent']}
                  arrow={false}
                  disabled={isRealEstate && property?.sold}
                >
                  {isRealEstate
                    ? property?.sold
                      ? translations.sold[router.locale]
                      : translations.inquire[router.locale]
                    : translations.book[router.locale]}
                </Button>
              </span>
            )}
          </div>
        </div>

        {!isRealEstate && (
          <div
            className={withModifiers(
              'card__bonuses',
              [
                includes(bonuses, true) &&
                  (isDesktop ? !show && 'is-shown' : 'is-shown')
              ],
              styles
            )}
          >
            {bonuses.car && (
              <div className={styles.card__bonus}>
                <IconCar />
                {translations.freeCar[router.locale]}
              </div>
            )}

            {bonuses.night && (
              <div className={styles.card__bonus}>
                <IconMoon />
                {translations.freeNight[router.locale]}
              </div>
            )}

            {bonuses.gift && (
              <div className={styles.card__bonus}>
                <IconGift />
                {translations.freeGift[router.locale]}
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles.card__body}>
        {isRealEstate ? (
          <Estate
            expandable={expandable}
            show={show}
            setShow={setShow}
            property={property}
            cardTranslations={cardTranslations}
            translations={translations}
          />
        ) : (
          <Reservation
            setBonuses={setBonuses}
            show={show}
            setShow={setShow}
            property={property}
            expandable={expandable}
            bonuses={bonuses}
            translations={translations}
            {...props}
          />
        )}
      </div>
    </div>
  )
}

export default Card
